<template>
  <el-dialog
    :title="$t('page.users.orderConfirm.offlinePaymentInfo')"
    :visible.sync="dialogVisible"
    width="500px"
    @close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="payment-info" v-html="offlinePayInfo">
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleConfirm">{{ $t('message.common.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'OfflinePay',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  data() {
    return {
      offlinePayInfo: '',
    }
  },
  mounted() {
    this.getData();
  },
  methods: {
    handleClose() {
      this.$emit('update:visible', false);
    },
    getData() {
      this.$axios.get("/api/index/getInfoDetail", {
        params: {
          id: 34
        }
      }).then(res => {
        console.log(res)
        this.offlinePayInfo = res.data.content
      })
    },
    handleConfirm() {
      this.$emit('confirm');
      this.handleClose();
    }
  }
};
</script>

<style scoped lang="scss">
.payment-info {
  line-height: 1.8;
  font-size: 14px;

  .account-details {
    background-color: #f7f7f7;
    padding: 15px;
    border-radius: 4px;
    margin: 15px 0;

    .item {
      display: flex;
      margin-bottom: 10px;

      .label {
        font-weight: bold;
        width: 120px;
        color: #333;
      }

      .value {
        color: #555;
      }
    }
  }

  .note {
    font-size: 12px;
    color: #999;
  }
}
</style>
